;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { Marker, InfoWindow } from '@react-google-maps/api';
import Link from 'next/link';
import { getI18nUtils } from '../i18n/i18n-utils';
import { getAgencyDisplayTitle } from '../utils/agencyBranding';

import mapMarkerIcon from '../icons/mapmarker.svg';
import mapMarkerSandYou from '../icons/mapmarker-sandyou.svg';

const AgencyMapMarker = ({ dictionary, agencyGroup, agencySelected, setAgencySelected, prependBrandName = false }) => {
  const { formatMessage } = getI18nUtils(dictionary);
  const getTitleWithBrand = (agencyTitle: string) => getAgencyDisplayTitle({ title: agencyTitle, prependBrandName });
  const group = agencyGroup.length > 1;
  const { lat, lng, title, address1, address2, postalCode, city, uri, apps } = agencyGroup[0];
  const address = `Synergie,${address1},${address2 ? `${address2}` : ''}${postalCode},${city}`;
  const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;
  const isSandYou = apps.includes('sandyou.be');

  let isIdPresent = false;
  if (agencySelected) isIdPresent = agencyGroup.some((obj) => obj.id === agencySelected.id);

  return (
    <Marker
      position={{ lat, lng }}
      icon={{ url: (isSandYou ? mapMarkerSandYou : mapMarkerIcon).src }}
      onClick={() => setAgencySelected(agencyGroup[0])}
    >
      {isIdPresent && (
        <InfoWindow position={{ lat, lng }} onCloseClick={setAgencySelected}>
          <div style={{ opacity: 0.75, margin: 20 }} className="info-window">
            {group ? (
              agencyGroup
                .sort((agA, agB) => agA.title.localeCompare(agB.title))
                .map((ag) => (
                  <p key={ag._id ?? ag.title}>
                    <strong>{getTitleWithBrand(ag.title)}</strong>
                  </p>
                ))
            ) : (
              <h6>{getTitleWithBrand(title)}</h6>
            )}
            <address>
              {address1}
              <br />
              {address2 ? <span>{address2}</span> : null}
              {`${postalCode} ${city}`}
            </address>
            <a href={googleMapsUrl} target="_blank" rel="noreferrer noopener" className="d-block my-2">
              {formatMessage({ id: 'route' })}
            </a>
            {!group && <Link href={uri}>{formatMessage({ id: 'agency-teaser-read-more' })}</Link>}
          </div>
        </InfoWindow>
      )}
    </Marker>
  );
};

export default AgencyMapMarker;
